var simplifyTextAttributes = function simplifyTextAttributes(multivalue) {
  return function (data) {
    return Object.keys(data).reduce(aggregateValues(data, multivalue), {});
  };
};

var aggregateValues = function aggregateValues(data, multivalue) {
  return function (index, lang) {
    var obj = data[lang];
    index[lang] = multivalue ? obj.map(getValue) : obj.value;
    return index;
  };
};

var getValue = function getValue(obj) {
  return obj.value;
};

var singleValue = simplifyTextAttributes(false);
module.exports = {
  labels: singleValue,
  descriptions: singleValue,
  aliases: simplifyTextAttributes(true)
};